import type { CSSProperties, ReactNode } from 'react';
import { FONT_DISPLAY } from '../../tokens';

interface SectionH2Props {
  children: ReactNode;
  style?: CSSProperties;
}

/** Standard section heading in the display face. */
export function SectionH2({ children, style = {} }: SectionH2Props) {
  return (
    <h2
      style={{
        fontFamily: FONT_DISPLAY,
        fontSize: 'clamp(2.4rem,5vw,4rem)',
        fontWeight: 400,
        letterSpacing: '0.02em',
        lineHeight: 1,
        textTransform: 'uppercase',
        ...style,
      }}
    >
      {children}
    </h2>
  );
}
